var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5969 37.3006L60.5783 37.3098C58.3845 38.9922 57.455 41.8551 58.2359 44.5043L58.2451 44.5229C59.4906 48.7337 56.4047 52.9814 52.0173 53.0931H51.9988C49.2288 53.1674 46.7934 54.9334 45.8731 57.5454V57.5547C44.4044 61.7003 39.4038 63.3269 35.7879 60.8264C33.5426 59.2933 30.5745 59.2133 28.2122 60.8264H28.203C24.5872 63.3176 19.5864 61.7002 18.127 57.5453C17.1985 54.9268 14.7668 53.1672 12.0015 53.0929H11.9829C7.59562 52.9813 4.5095 48.7336 5.75513 44.5228L5.76437 44.5042C6.545 41.8549 5.6155 38.9921 3.422 37.3097L3.40337 37.3004C-0.082375 34.6233 -0.082375 29.3809 3.40337 26.7039L3.422 26.6947C5.6155 25.0123 6.545 22.1493 5.75513 19.5002V19.4816C4.50013 15.2709 7.5955 11.0229 11.9829 10.9114H12.0015C14.7621 10.8371 17.2068 9.07094 18.127 6.45906V6.44981C19.5863 2.30418 24.5872 0.67756 28.203 3.17806H28.2122C30.4895 4.74894 33.5011 4.74894 35.7879 3.17806C39.4401 0.655935 44.413 2.32906 45.8731 6.44981V6.45906C46.7934 9.06169 49.2286 10.8372 51.9988 10.9114H52.0173C56.4046 11.0229 59.4906 15.2709 58.2451 19.4816L58.2359 19.5002C57.455 22.1493 58.3845 25.0123 60.5783 26.6947L60.5969 26.7039C64.0826 29.3809 64.0826 34.6234 60.5969 37.3006Z",
    fill: "#8B8B8B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12858_34437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 32C20 33.5759 20.3104 35.1363 20.9134 36.5922C21.5165 38.0481 22.4004 39.371 23.5147 40.4853C24.629 41.5996 25.9519 42.4835 27.4078 43.0866C28.8637 43.6896 30.4241 44 32 44C33.5759 44 35.1363 43.6896 36.5922 43.0866C38.0481 42.4835 39.371 41.5996 40.4853 40.4853C41.5996 39.371 42.4835 38.0481 43.0866 36.5922C43.6896 35.1363 44 33.5759 44 32C44 28.8174 42.7357 25.7652 40.4853 23.5147C38.2348 21.2643 35.1826 20 32 20C28.8174 20 25.7652 21.2643 23.5147 23.5147C21.2643 25.7652 20 28.8174 20 32Z",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 25.3335V32.0002L36 36.0002",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12858_34437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentWait);
export default __webpack_public_path__ + "static/media/payment_wait.1cc7dd2d47f241ab59f1b99091d98716.svg";
export { ForwardRef as ReactComponent };